module.exports = __webpack_public_path__ + "img/event-session-coaching-2024.7f1fa27.jpg";